module.exports = __webpack_public_path__ + "media/images/gifts/light/sug_luz_4-cd4815af276ce28c27b324adc102af7f.jpg";